<section class="pt-16 pb-8 px-container">
    <app-breadcrumb-backoffice [items]="[{ label: 'Home', route: '/backoffice/home' }, { label: 'Making Teca', route: '/backoffice/making-teca/' }, { label: 'Modifica Making Teca', active: true }]"></app-breadcrumb-backoffice>
    <h1 class="lg:text-4xl text-2xl font-mono text-center uppercase">MODIFICA MAKING TECA POST</h1>
</section>


<section class="pb-16 mb-8 px-container">
    <form [formGroup]="formPost" (ngSubmit)="onSubmit()">
        <div class="flex flex-col gap-8">
            <div class="flex lg:flex-row flex-col gap-8">
                <div class="lg:w-1/2 w-full">
                    <label>* Titolo</label>
                    <input type="text" pInputText placeholder="Titolo" formControlName="titolo" required />
                    <small class="text-red-600 block mt-4 font-medium"
                        *ngIf="formPost.get('titolo')?.hasError('required') && (formPost.get('titolo')?.dirty || formPost.get('titolo')?.touched)">Il
                        titolo è obbligatorio!.</small>
                </div>
                <div class="lg:w-1/2 w-full">
                    <label>* Data</label>
                    <br />
                    <p-calendar formControlName="data" class="w-full grid" dateFormat="dd/mm/yy" [showIcon]="true" />
                    <small class="text-red-600 block mt-4 font-medium"
                        *ngIf="formPost.get('data')?.hasError('required') && (formPost.get('data')?.dirty || formPost.get('data')?.touched)">La
                        data è obbligatoria!.</small>
                </div>
            </div>
            <div class="flex lg:flex-row flex-col-reverse gap-8 items-center">
                <div class="lg:w-1/2 w-full">
                    <label>* Immagine Box</label>
                    <p-fileUpload mode="advanced" [multiple]="false" chooseLabel="Seleziona un'immagine"
                        accept="image/*" maxFileSize="1000000000" cancelLabel="Rimuovi" [showUploadButton]="false"
                        (onSelect)="onImmagineUpload($event)" (onRemove)="onRemoveImmagineUpload($event)"
                        (onClear)="onRemoveImmagineUpload($event)" />
                </div>
                <div class="lg:w-1/2 w-full text-end" *ngIf="making_teca_post?.immagine!.length > 0">
                    <button class="btn-outln-backoffice p-3 lg:w-1/2 w-full font-bold" type="button" (click)="show_image = !show_image">{{show_image ? 'Nascondi' : 'Mostra'}} immagine caricata</button>
                    <img [src]="(making_teca_post?.immagine + '?type=making-teca' | image)" alt="Immagine Post" *ngIf="show_image" class="mt-8">
                </div>
            </div>
        </div>

        <div class="flex flex-col gap-8 mt-16">
            <div class="w-full">
                <h1 class="lg:text-4xl text-2xl font-mono text-center uppercase">MODIFICA CONTENUTO DEL POST</h1>
            </div>
            <ng-container *ngFor="let data of making_teca_post_data; let i = index">
                <div class="w-full">
                    <label>* Titolo</label>
                    <input type="text" pInputText placeholder="Titolo" [formControlName]="'titolo_' + i" required />
                </div>
                <div class="w-full">
                    <label>Descrizione</label>
                    <p-editor [style]="{ height: '150px' }" [formControlName]="'descrizione_' + i" />
                </div>
                <div class="flex lg:flex-row flex-col-reverse gap-8 items-center">
                    <div class="lg:w-1/2 w-full">
                        <label>Immagine Contenuto</label>
                        <p-fileUpload mode="advanced" [multiple]="false" chooseLabel="Seleziona un'immagine" accept="image/*" maxFileSize="1000000000" cancelLabel="Rimuovi" [showUploadButton]="false" (onSelect)="onImmagineContenutoUpload($event, i)" (onRemove)="onRemoveImmagineContenutoUpload($event, i)" (onClear)="onRemoveImmagineContenutoUpload($event, i)" />
                    </div>
                    <div class="lg:w-1/2 w-full text-end" *ngIf="data.immagine.length > 0">
                        <button class="btn-outln-backoffice p-3 lg:w-1/2 w-full font-bold" type="button" (click)="data.show_immagine= !data.show_immagine">{{data.show_immagine ? 'Nascondi' : 'Mostra'}} immagine caricata</button>
                        <img [src]="(data?.immagine + '?type=making-teca' | image)" alt="Immagine Post" *ngIf="data.show_immagine" class="mt-8">
                    </div>
                </div>
                <div class="flex lg:flex-row flex-col-reverse gap-8 items-center">
                    <div class="lg:w-1/2 w-full"></div>
                    <div class="lg:w-1/2 w-full text-end">
                        <button class="btn-danger-backoffice p-3 lg:w-1/2 w-full font-medium" type="button" (click)="onRemoveContenuto(i)">Rimuovi contenuto</button>
                    </div>
                </div>  
                <hr *ngIf="making_teca_post_data.length > 1">
            </ng-container>
        </div>

        <div class="flex lg:flex-row flex-col gap-8 my-8">
            <div class="lg:w-1/3 w-full">
                <button class="btn-outln-backoffice p-3 w-full font-medium" type="button" (click)="onAddContenuto()">Aggiungi un contenuto</button>
            </div>
            <div class="lg:w-1/3 w-full">
                <button class="btn-outln-backoffice p-3 w-full font-medium" type="submit" [disabled]="!formPost.valid">Modifica post</button>
            </div>
            <div class="lg:w-1/3 w-full">
                <p-confirmPopup #confirmDeletePopupRef>
                    <ng-template pTemplate="headless" let-message>
                        <div class="border-round p-3">
                            <span class="text-base">{{ message.message }}</span>
                            <div class="flex align-items-center gap-2 mt-3">
                                <p-button class="text-center btn-danger-backoffice p-2 w-full font-medium" (click)="onDelete()" label="Elimina" />
                                <p-button class="text-center btn-outln-backoffice p-2 w-full font-medium" (click)="onAnnulla()" label="Annulla" />
                            </div>
                        </div>
                    </ng-template>
                </p-confirmPopup>
                <button class="btn-danger-backoffice p-3 w-full font-medium" type="button" (click)="onDeletePostPopup($event)">Elimina post</button>
            </div>
        </div>
        
    </form>
</section>